import { Button, Dropdown, Input, Menu, Modal, message } from "antd";
import SubMenu from "antd/es/menu/SubMenu";
import { useEffect, useState } from "react";
import FileItemView from "./FileItemView";
import { DeleteFilled, PlusCircleOutlined } from '@ant-design/icons';
import { URL_fileType_addFileTYpe, URL_fileType_delete, URL_fileType_getFileType, URL_fileType_moveDown, URL_fileType_moveUp, URL_fileType_updateName, requestUrl } from "./Utils/UrlUtils";
import { FileTypeEntity } from "./Entity";
import PointImg from '../../src/res/three_point_white.png'
export default () => {
    const [collapsed, setCollapsed] = useState<boolean>(false)
    const [fileTypeList, setFileTypeList] = useState<FileTypeEntity[]>([])
    const [messageApi, contextHolder] = message.useMessage();
    const [addFileOpen, setAddFileOpen] = useState<boolean>(false)
    const [updateFileOpen, setUpdateFileOpen] = useState<boolean>(false)
    const [clickFileType, setClickFileType] = useState<FileTypeEntity>({ name: '', superId: -2 })
    const [addFileNameValue, setAddFileNameValue] = useState<string>('')//点击新增类别 文件名称
    const [updateFileNameValue, setUpdateFileNameValue] = useState<string>('')//点击修改 文件名称
    const [selectedKeys, setSelectedKeys] = useState<string[]>([''])
    const [openKeys, setOpenKeys] = useState<string[]>([''])
    const [menuData, setMenuData] = useState<{ [key: string]: FileTypeEntity }>({})
    const [currentSelectData, setCurrentSelectData] = useState<FileTypeEntity>()
    const [loading, setLoading] = useState<boolean>(false)  //是否正在提交
    const menu = (data: FileTypeEntity, isFirst: boolean, isLast: boolean) => {
        let hasChild = data.child?.length != 0
        return <Menu
            onClick={(e: any) => {
                e.domEvent.stopPropagation()
            }}>
            {isFirst ? <></> : <Menu.Item onClick={() => moveFile(true, data.id)}>上移</Menu.Item>}
            {isLast ? <></> : <Menu.Item onClick={() => moveFile(false, data.id)}>下移</Menu.Item>}
            <Menu.Item onClick={() => {
                setClickFileType(data)
                setAddFileOpen(true)
            }}>新增类别</Menu.Item>
            <Menu.Item onClick={() => {
                setClickFileType(data)
                setUpdateFileOpen(true)
            }}>修改</Menu.Item>
            {hasChild ? <></> : <Menu.Item onClick={() => {
                // setDeleteId(data.id)
                // setClickFileType(data)
                if (data.id) {
                    deleteFileTYpe(data.id)
                }
            }}>删除</Menu.Item>}
        </Menu>
    }

    const MenuItemView = (p: { data: FileTypeEntity, isFirst: boolean, isLast: boolean }) => {
        return (
            <div style={{ display: 'flex', width: '100%', justifyItems: 'center', alignItems: 'center' }}>
                <div onClick={() => { }}>{p.data.name}</div>
                <div style={{ flex: '1', display: 'flex', justifyContent: 'flex-end' }}>
                    <Dropdown overlay={menu(p.data, p.isFirst, p.isLast)} placement="bottomLeft">
                        <img src={PointImg} />
                    </Dropdown>
                </div>
            </div>
        )
    }
    /**
     * 获取 文件列表
     */
    const getFileType = () => {
        requestUrl({
            url: URL_fileType_getFileType,
            method: 'GET',
            success: (data: FileTypeEntity[]) => {
                setFileTypeList(data)
                if (data.length != 0) {
                    getDefaultKeys(data[0], [], [], '')
                }
            },
            fail: (msg) => {
                messageApi.open({ type: 'error', content: msg });
            }
        })
    }

    /**
     * 默认展示第一项
     * @param data 
     * @param selectedKeys 
     * @param openKeys 
     * @returns 
     */
    const getDefaultKeys = (data: FileTypeEntity, selectedKeys: string[], openKeys: string[], title: string) => {
        if (!data.id) return
        openKeys.push(data.id.toString())
        let ti = title + '-' + data.name
        if (data.child?.length == 0) {
            if (selectedKeys.length == 0) {
                setSelectedKeys([data.id.toString()])
                setOpenKeys(openKeys)
                selectedKeys.push(data.id.toString())
                setCurrentSelectData(data)
            }
        } else {
            data.child?.map((d) => {
                getDefaultKeys(d, selectedKeys, openKeys, ti)
            })
        }
    }

    /**
     * 新增 类别 
     * @param name 
     * @param superId 
     * @returns 
     */
    const addFileTYpe = async (name: string, superId?: number) => {
        if (name == '') return
        let sId = superId
        if (!sId) {
            //表示 添加在首列
            sId = -1
        }
        let body = {
            name: name,
            superId: sId
        }
        setLoading(true)
        await requestUrl({
            url: URL_fileType_addFileTYpe,
            method: 'POST',
            body: JSON.stringify(body),
            success(data: FileTypeEntity[]) {
                setFileTypeList(data)
            },
            fail(msg) {
                messageApi.open({ type: 'error', content: msg });
            },
            finally() {
                setLoading(false)
            },
        })
    }
    /**
     * 删除文件夹
     * @param id 
     * @returns 
     */
    const deleteFileTYpe = (id: number) => {
        if (!id) return
        let body = {
            id: id
        }
        requestUrl({
            url: URL_fileType_delete,
            method: 'POST',
            body: JSON.stringify(body),
            success: (data: FileTypeEntity[]) => {
                setFileTypeList(data)
            },
            fail: (msg) => {
                messageApi.open({ type: 'error', content: msg });
            }
        })
    }

    /**
     * 修改文件夹
     * @param id 
     * @returns 
     */
    const updateName = async (name: string, id?: number) => {
        if (!id) return
        if (name == '') return
        let body = {
            id: id,
            name: name
        }
        setLoading(true)
        await requestUrl({
            url: URL_fileType_updateName,
            method: 'POST',
            body: JSON.stringify(body),
            success: (data: FileTypeEntity[]) => {
                setFileTypeList(data)
            },
            fail: (msg) => {
                messageApi.open({ type: 'error', content: msg });
            }, finally: () => {
                setLoading(false)
            }
        })
    }

    /**
     * 移动文件夹
     * @param id 
     * @param isMoveUp true 上移 false 下移 
     * @returns 
     */
    const moveFile = (isMoveUp: boolean, id?: number) => {
        if (!id) return
        let url = isMoveUp ? URL_fileType_moveUp : URL_fileType_moveDown
        url = url + '?id=' + id
        requestUrl({
            url: url,
            method: 'GET',
            // body:JSON.stringify(body),
            success: (data: FileTypeEntity[]) => {
                setFileTypeList(data)
            },
            fail: (msg) => {
                messageApi.open({ type: 'error', content: msg });
            }
        })
    }
    useEffect(() => {
        getFileType()
    }, [1])

    const getItemView = (d: FileTypeEntity, index: number, array: FileTypeEntity[], title: string) => {
        if (!d.id) return <></>
        if (d.child?.length == 0) {
            menuData[d.id] = d
            return (
                <Menu.Item key={d.id}>
                    <MenuItemView data={d} isFirst={index == 0} isLast={index == array.length - 1} />
                </Menu.Item>
            )
        } else {
            let ti = title + '-' + d.name
            return (
                <SubMenu
                    key={d.id}
                    title={<MenuItemView data={d} isFirst={index == 0} isLast={index == array.length - 1} />}>
                    {
                        d.child?.map((ditem, idx, ary) => {
                            return (
                                getItemView(ditem, idx, ary, ti)
                            )
                        })
                    }
                </SubMenu>
            )
        }
    }
    return (
        <>
            {contextHolder}
            <div style={{ display: 'flex', height: '100%', width: '100%' }}>
                <Menu
                    style={{ width: 257 }}
                    // defaultSelectedKeys={['18']}
                    selectedKeys={selectedKeys}
                    openKeys={openKeys}
                    onOpenChange={(openKeys) => {
                        setOpenKeys(openKeys)
                    }}
                    onClick={(i) => {
                        if (i.key == '-2') return //新增类别
                        setSelectedKeys([i.key])
                        if (i.key == '-1') {
                            //回收站
                            setCurrentSelectData({ id: -1, name: '回收站' })
                        } else {
                            setCurrentSelectData(menuData[i.key])
                        }
                    }}
                    mode="inline"
                    theme="dark"
                    inlineCollapsed={collapsed}
                >
                    {
                        fileTypeList.map((d, index, array) => {
                            return getItemView(d, index, array, '')
                        })
                    }
                    <Menu.Item key={-2} onClick={() => {
                        setAddFileOpen(true)
                    }}>
                        <PlusCircleOutlined style={{ color: 'white', marginRight: '10px' }} />
                        新增类别
                    </Menu.Item>
                    <Menu.Item key={-1}>
                        {/* <DeleteFilled /> */}
                        <DeleteFilled style={{ marginRight: '10px' }} />回收站
                    </Menu.Item>
                </Menu>
                <div style={{ flex: '1', height: '100%', width: '100%', display: 'flex', paddingLeft: '15px', paddingRight: '15px', flexDirection: 'column' }}>
                    {
                        currentSelectData ? <FileItemView data={currentSelectData} id={0} messageApi={messageApi} /> : <></>
                    }
                </div>
            </div>
            <Modal
                open={addFileOpen}
                maskClosable={false}
                destroyOnClose
                title={"新增类别 - " + clickFileType.name}
                afterClose={() => {
                    setLoading(false)
                    setAddFileNameValue('')
                }}
                onCancel={() => {
                    setAddFileOpen(false)
                    setAddFileNameValue('')
                }}
                footer={<Button type="primary" loading={loading} onClick={async () => {
                    if (addFileNameValue == '') return
                    await addFileTYpe(addFileNameValue, clickFileType.id)
                    setAddFileOpen(false)
                }}>{loading ? '提交中' : '确定'}</Button>}
            >
                <Input value={addFileNameValue} onChange={(e) => setAddFileNameValue(e.target.value)} />
            </Modal>
            <Modal
                open={updateFileOpen}
                maskClosable={false}
                destroyOnClose
                title={"修改文件名称 - " + clickFileType.name}
                afterClose={() => {
                    setLoading(false)
                    setUpdateFileNameValue('')
                }}
                onCancel={() => {
                    setUpdateFileOpen(false)
                }}
                footer={<Button type="primary" loading={loading} onClick={async () => {
                    if (updateFileNameValue == '') return
                    await updateName(updateFileNameValue, clickFileType.id)
                    setUpdateFileOpen(false)
                }}>{loading ? '提交中' : '确定'}</Button>}
            >
                <Input value={updateFileNameValue} onChange={(e) => setUpdateFileNameValue(e.target.value)} />
            </Modal>
        </>
    )
}